import React, { useState, useEffect, useRef } from 'react';
import { LegacyStack, InlineError } from '@shopify/polaris';
import {FormProvider, Util} from '@thinkwell/react.common';
import {AppProvider, TextField} from '@thinkwell/react.polaris';
import ProxyForm from './ProxyForm'
import ContactForm from '../ContactForm'
import PasswordForm from '../PasswordForm'
import ReCaptchaField from './ReCaptchaField';

export default function Registration(props) {
  Util.hideLoader();

  const isHomeschool = !!props.shop_name.match(/tw02/i)

  const checkout_url = Util.getParam(window.location.href, 'checkout_url')

  return (<AppProvider><FormProvider>
    <ProxyForm
      action="/account"
      submitText="Create"
      proxy={{action: '/accounts/registration', host: props.host, shop_name: props.shop_name}}
      bottomLink={{href: `/account/login${checkout_url ? `?checkout_url=${checkout_url}` : ''}`, text: "Login to an Existing Account"}}
    >
      { isHomeschool ?
        <p className="breadcrumbs Polaris-Label__Text">
        Please enter your information below. If you are the parent or instructor, you will create and assign your student account after completing your purchase.
        </p> : null
      }
      <input readOnly type="hidden" name="form_type" value="create_customer"/>
      { checkout_url ? <input readOnly type="hidden" name="return_to" value={decodeURIComponent(checkout_url).replace(window.location.origin, "")} /> : null }
      <ContactForm vertical
        required={['first_name', 'last_name', 'email']}
        names={{first_name: 'customer[first_name]', last_name: 'customer[last_name]', email: 'customer[email]'}}
        labels={{first_name: isHomeschool ? 'First name (If you are signing up for a student, this is your parent/instructor account)' : 'First name'}}
      >
        <PasswordForm names={{password: 'customer[password]'}} />
        { isHomeschool ? null :
          <TextField
          label="Student ID (optional)"
          name="customer[note][student_id]"
          />
        }
      </ContactForm>
      <br/>
      { 
        props.recaptcha_site_secret ? 
          <ReCaptchaField siteSecret={props.recaptcha_site_secret} /> : null
      }
    </ProxyForm>
  </FormProvider></AppProvider>)
}
